module.exports = __webpack_public_path__ + "static/media/tech-mahindra-ctco.59c81bdb.svg";